package com.havn.app.core.designsystem

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput

fun Modifier.havnRefreshStartGate(
    scrollState: ScrollState,
    onGestureStartedAtTop: (Boolean) -> Unit
): Modifier = pointerInput(scrollState) {
    awaitEachGesture {
        awaitFirstDown(requireUnconsumed = false)
        onGestureStartedAtTop(scrollState.value == 0)
    }
}

fun Modifier.havnRefreshStartGate(
    listState: LazyListState,
    onGestureStartedAtTop: (Boolean) -> Unit
): Modifier = pointerInput(listState) {
    awaitEachGesture {
        awaitFirstDown(requireUnconsumed = false)
        onGestureStartedAtTop(
            listState.firstVisibleItemIndex == 0 &&
                listState.firstVisibleItemScrollOffset == 0
        )
    }
}
